/* eslint-disable no-unused-vars */
import { find, get } from "lodash";
import React, { useEffect } from "react";
import * as MobileDetect from "react-device-detect";
import { partnerInfo } from "~/configs/partnerDetails";
import { LINK_ANDROID_APP, LINK_IOS_APP } from "~/utils/manageResource";

const info = get(partnerInfo, "info");
const iosUrl = find(info, { key: "ios" });
const androidUrl = find(info, { key: "android" });

const Download = () => {
  let url = "/";
  if (MobileDetect.isIOS) {
    url = LINK_IOS_APP;
  } else if (MobileDetect.isAndroid) {
    url = LINK_ANDROID_APP;
  } else {
    url = "/";
  }

  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return <div>"</div>;
};

export default Download;
